import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.primary.dark};
  font-family: sans-serif;
  position: relative;
  z-index: 1;
`;
